module.exports = __webpack_public_path__ + "media/images/sp/plans/icon1-3e3042febd3bc6ea9f80f738727ddf73.svg";